export function isType<TObj extends { __typename?: string }, TTypename extends TObj['__typename']>(
  obj: TObj,
  typename: TTypename
): obj is Extract<TObj, { __typename: TTypename }> {
  return obj.__typename === typename;
}
